export const dictionaryKeys = {
  all: ['org', 'dictionary'] as const,
  attributes: () => [...dictionaryKeys.all, 'attributes'] as const,
  attribute: (id: string) => [...dictionaryKeys.attributes(), id] as const,
  customizations: () => [...dictionaryKeys.all, 'customizations'] as const,
  productTypes: () => [...dictionaryKeys.all, 'product-types'] as const,
  productType: (id: string) => [...dictionaryKeys.productTypes(), id] as const,
  sizeSets: () => [...dictionaryKeys.all, 'size-sets'] as const,
  sizeSet: (id: string) => [...dictionaryKeys.sizeSets(), id] as const,
  stonePriceRules: () => [...dictionaryKeys.all, 'stone-price-rules'] as const,
  skuRules: () => [...dictionaryKeys.all, 'sku-rules'] as const,
  skuRule: (id: string) => [...dictionaryKeys.skuRules(), id] as const,
  /** Keyed by the whole request: the preview is a read of unsaved templates. */
  skuRulePreview: (body: unknown) => [...dictionaryKeys.skuRules(), 'preview', body] as const,
  skuRuleResolve: (productTypeId: string | null) =>
    [...dictionaryKeys.skuRules(), 'resolve', productTypeId ?? ''] as const,
  skuRuleRuns: (id: string) => [...dictionaryKeys.skuRule(id), 'runs'] as const,
  skuRuleRun: (id: string, runId: string) => [...dictionaryKeys.skuRuleRuns(id), runId] as const,
};
